import { Link, useLocation } from "react-router-dom";

export default function SubpageLayout({ title, items, children }) {
  const location = useLocation();

  return (
    <div className="flex flex-col lg:flex-row gap-4 min-h-[calc(100vh-8rem)]">
      <aside className="w-full lg:w-56 shrink-0">
        <div className="bg-white-100 border border-white-200 rounded-lg overflow-hidden">
          {title ? (
            <div className="px-4 py-3 border-b border-white-200 text-sm font-bold text-black-200">
              {title}
            </div>
          ) : null}
          <nav className="p-2 flex lg:flex-col gap-1 overflow-x-auto">
            {items.map((item) => {
              const active =
                location.pathname === item.to ||
                location.pathname.startsWith(item.to + "/");
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={
                    "whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-semibold transition-colors " +
                    (active
                      ? "bg-primary-500 text-white-100"
                      : "text-black-300 hover:bg-white-200 hover:text-black-200")
                  }
                >
                  {item.title}
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
